import { Control, FieldPath, FieldValues } from 'react-hook-form';
import SingleSelectInput from '@/components/form/SingleSelectInput.tsx';
import Option from '@/components/form/types/Option.ts';
import { countries, preferredCountryCodes } from '@/utils/countryUtils.ts';

const countryOptions: Option[] = [
  ...preferredCountryCodes.map(
    (code) => countries.find((country) => country.code === code)!,
  ),
  ...countries.filter(
    (country) => !preferredCountryCodes.includes(country.code),
  ),
].map((country) => ({
  value: country.code,
  label: `${country.flag} ${country.name}`,
}));

type CountrySelectInputProps<T extends FieldValues> = {
  fieldName: FieldPath<T>;
  control: Control<T>;
  label?: string;
  required?: boolean;
  hint?: string;
  error?: string;
  className?: string;
};

const CountrySelectInput = <T extends FieldValues>(
  props: CountrySelectInputProps<T>,
) => {
  return (
    <SingleSelectInput
      {...props}
      options={countryOptions}
      placeholder="Wybierz kraj"
    />
  );
};

export default CountrySelectInput;
